import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import triggerNotification from '../actions/triggerNotification';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const NotifyContainer = styled.div`
    position: fixed;
    bottom: 40px;
    left: 50%;
    z-index: 10000;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transform: ${props => props.show ? 'translate(-50%, 0)' : 'translate(-50%, 150%)'};
    opacity: ${props => props.show ? '1' : '0'};
    pointer-events: ${props => props.show ? 'auto' : 'none'};
`;

const ToastCard = styled.div`
    background: ${props => props.status === 'FAILED' 
        ? 'linear-gradient(135deg, #f43f5e 0%, #be123c 100%)' 
        : 'linear-gradient(135deg, #2CAE66 0%, #15803d 100%)'};
    box-shadow: 0px 12px 36px rgba(0, 0, 0, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    padding: 16px 20px;
    min-width: 320px;
    max-width: 450px;
    position: relative;
    overflow: hidden;
    color: #ffffff;
`;

const IconWrapper = styled.div`
    width: 44px;
    height: 44px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.2);
    color: #ffffff;
    
    svg {
        font-size: 26px;
    }
`;

const ContentWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-right: 16px;
`;

const Title = styled.div`
    font-size: 13px;
    font-weight: 800;
    text-transform: uppercase;
    color: #ffffff;
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    letter-spacing: 0.5px;
    
    &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #ffffff;
        margin-right: 8px;
        box-shadow: 0 0 4px rgba(255,255,255,0.8);
    }
`;

const Message = styled.div`
    font-size: 15px;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
    line-height: 1.4;
`;

const CloseButton = styled.button`
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
    flex-shrink: 0;
    
    &:hover {
        background: rgba(255, 255, 255, 0.3);
    }
    
    svg {
        font-size: 18px;
    }
`;

function Notification({
    messageText = '',
    notificationHandler,
    status = 'SUCCESS',
    location
}) {
    const [show, setShow] = useState(false);

    // Automatically vanish notification when moving to another screen / route
    useEffect(() => {
        setShow(false);
        notificationHandler({});
    }, [location?.pathname]);

    useEffect(() => {
        if (messageText) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [messageText]);

    const handleClose = () => {
        setShow(false);
        setTimeout(() => {
            notificationHandler({});
        }, 400); 
    };

    return (
        <NotifyContainer show={show}>
            <ToastCard status={status}>
                <IconWrapper status={status}>
                    {status === 'FAILED' ? <ErrorOutlineIcon /> : <CheckIcon />}
                </IconWrapper>
                <ContentWrapper>
                    <Title status={status}>{status}</Title>
                    <Message>{messageText}</Message>
                </ContentWrapper>
                <CloseButton onClick={handleClose}>
                    <CloseIcon />
                </CloseButton>
            </ToastCard>
        </NotifyContainer>
    );
}

function mapStateToProps({ app = {} }) {
    const { notification = {} } = app;
    const { messageText = '', status = 'SUCCESS' } = notification;
    return {
        messageText,
        status
    };
}

const mapDispatchToProps = dispatch => {
    return {
        notificationHandler: bindActionCreators(triggerNotification, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Notification));